var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmedAccessRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "117px",
    height: "155px",
    viewBox: "0 0 117 155",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51F2DE19-6C8A-4C8E-B727-4ED3A222740A@0.50x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.5,4.91666667 C15.93,4.91666667 4.91666667,15.93 4.91666667,29.5 C4.91666667,43.07 15.93,54.0833333 29.5,54.0833333 C43.07,54.0833333 54.0833333,43.07 54.0833333,29.5 C54.0833333,15.93 43.07,4.91666667 29.5,4.91666667 Z M24.5833333,41.7916667 L12.2916667,29.5 L15.7579167,26.03375 L24.5833333,34.8345833 L43.2420833,16.1758333 L46.7083333,19.6666667 L24.5833333,41.7916667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "D\\xE9l\\xE9gation-Droits",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.1---Demande-d'acces---Entrer-adresse-mail-admin",
    transform: "translate(-664.000000, -375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Illustration",
    transform: "translate(664.000000, 375.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bouclier",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113,18.0766644 C99.5019848,17.5924681 87.1050162,15.4741089 76.8489715,11.9031607 C68.1221581,8.85675857 61.250812,4.82178884 56.5,0 C51.749188,4.82178884 44.8574522,8.85675857 36.1306388,11.9031607 C25.874594,15.4741089 13.4776254,17.5924681 0,18.0766644 C0.428184771,66.7585743 6.48394082,80.8204438 23.3666546,96.7585743 C30.1156622,103.113652 37.3336341,107.431069 43.7156261,111.264291 C48.5683869,114.169469 53.0541321,116.852724 56.5,120 C59.9458679,116.852724 64.4112234,114.169469 69.2843739,111.264291 C75.6459762,107.431069 82.8843378,103.113652 89.6129556,96.7585743 C106.516059,80.8204438 112.551425,66.7585743 113,18.0766644 Z",
    id: "Fill-561",
    fill: "#FF5C35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/action/check_circle_24px",
    transform: "translate(26.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Selected-/-On-Primary-/-Inactive-",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillOpacity: 0.54,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.458333, -2.458333)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 63.9166667,
    height: 63.9166667
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\xC9toile",
    transform: "translate(85.000000, 3.000000)",
    fill: "#FEC55C"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-862",
    points: "15.3671931 15.9933602 15.9933602 -1.42108547e-14 16.6195274 15.9933602 15.3671931 15.9933602"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-863",
    points: "15.3671931 15.9933602 15.9933602 31.9867205 16.6195274 15.9933602 15.3671931 15.9933602"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-864",
    points: "15.9933602 15.3671931 31.9866282 15.9933602 15.9933602 16.6195274 15.9933602 15.3671931"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-865",
    points: "15.9933602 15.3671931 -1.13686838e-13 15.9933602 15.9933602 16.6195274 15.9933602 15.3671931"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\xC9toile",
    transform: "translate(2.000000, 0.000000)",
    fill: "#FEC55C"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-862",
    points: "7.68359654 7.99668012 7.99668012 -1.42108547e-14 8.30976369 7.99668012 7.68359654 7.99668012"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-863",
    points: "7.68359654 7.99668012 7.99668012 15.9933602 8.30976369 7.99668012 7.68359654 7.99668012"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-864",
    points: "7.99668012 7.68359654 15.9933141 7.99668012 7.99668012 8.30976369 7.99668012 7.68359654"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-865",
    points: "7.99668012 7.68359654 -1.13686838e-13 7.99668012 7.99668012 8.30976369 7.99668012 7.68359654"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedAccessRight);
export default __webpack_public_path__ + "static/media/confirmedAccessRight.ebf6e30f61779619b1bf3229ef01c047.svg";
export { ForwardRef as ReactComponent };